import React from "react";

const Cgu = (): JSX.Element => {
    return <div>Cgu</div>;
};

export default Cgu;
